import BigNumber from 'bignumber.js';
// eslint-disable-next-line import/no-unused-modules
export const curveFunctionNumeric = ({ poly }: { poly: BigNumber[] }) => {
  return (x: BigNumber) =>
    poly[2]
      .multipliedBy(x.exponentiatedBy(2))
      .plus(poly[1].multipliedBy(x))
      .plus(poly[0]);
};
